
export function isNameValid(name: string) {
    return name.trim().length > 2;
}

export function validateMobile(mobile: string) {
    if (mobile.trim().length === 0) {
        return true;
    }

    if (mobile.trim().length < 6) {
        return false;
    }

    return /^[+]?[(]?[0-9]{1,4}[)]?[-\s./0-9]*$/.test(mobile.trim()) && /[0-9]{5,}/.test(mobile.replace(/[^0-9]/g, ''));
}

export function validateMail(mail: string) {
    if (mail.trim().length < 6) {
        return false;
    }

    return /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/.test(mail);
}